let type_request = null;
let data_element = null;
let listPayments = null;
let decidir = null
let decidirAgro = false;


export function main() {
    type_request = $("input[name=type_request]").val();
    if ((type_request != "tlmk" && $("#enrollment-id-input").val() != "" && $("#preOrderData").val() != "ERROR - PREORDER") || (type_request == "tlmk")) {
        if (type_request != "tlmk") {
        } else {
            hideSpinnerPayway();
        }
        $.ajax({
            url: '/PaymentToken/ListPaymentPayway',
            type: 'GET',
            dataType: 'json',
            success: function (res) {
                console.log(res);
                listPayments = res;
                getListTypePaymentMethod();
            }
        });
        let form = document.querySelector('#pay-button');
        addEvent(form, 'click', sendForm);
        let selectType = document.querySelector('#enrollment-card-type-input');
        addEvent(selectType, 'change', getListPaymentMethod);
        $(document).ready(function () { });
    }
    function FactoryDecidir() {
        
        let payWayUrl = document.getElementById("payway-url").value;
        let payWayKey = document.getElementById("payway-key").value;
        this.create = function (environment, cybersource) {
            let decidirInstance = null;
            decidirInstance = new Decidir(payWayUrl, true);
            decidirInstance.setPublishableKey(payWayKey);
            decidirInstance.setTimeout(10000);
            return decidirInstance;
        }
    }
    function addEvent(el, eventName, handler) {
        if (el.addEventListener) {
            el.addEventListener(eventName, handler);
        } else {
            el.attachEvent('on' + eventName, function () {
                handler.call(el);
            });
        }
    }
    function sdkResponseHandler(status, response) {
        console.log('respuesta', response);
        if (status !== 200 && status !== 201) {
            var btn = document.querySelector('#pay-button');
            addEvent(btn, 'click', sendForm);
            document.querySelector('#paymentToken').value = "No se logro realizar la petición";
            $("#tech-error-payway").html("No se logro realizar la petición");
            $("#pay-button").show();
            if (type_request != "tlmk") {
                tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
            } else {
                hideSpinnerPayway();
            }
        } else {
            $("#tech-error-payway").html("");
            document.querySelector('#paymentToken').value = response.id;
            document.querySelector('#bin').value = response.bin;
            console.log(response.id);
            data_element = (type_request == "tlmk") ? getElementsPayway(JSON.parse($("input[name=dato]").val())) : getElementsPayway(JSON.parse($("#preOrderData").val()).order);
            if (type_request != "tlmk") {
                $("#pay-button").hide();
                tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", true);
            } else {
                showSpinnerPayway();
                $("#pay-button").hide();
            }
            $.ajax({
                url: '/PaymentToken/CheckoutPaymentPayway',
                type: 'Post',
                data: data_element,
                success: function (response) {
                    console.log("terminando ...");
                    if (response.error == "" && response.statusPayway == "approved") {
                        $("#tech-error-payway").html("");
                        if (type_request == "tlmk") {
                            const Paywayform = document.querySelector('#payment-form');
                            Paywayform.action = '/PaymentToken/CompleteInfoPayway';
                            Paywayform.submit()
                        } else {
                            tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
                            tech.newEnrollment.submitEnrollmentForm();
                        }
                    } else {
                        $("#pay-button").show();
                        if (type_request != "tlmk") {
                            $("#tech-error-payway").html(response.error);
                            tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
                        } else {
                            hideSpinnerPayway();
                            showPaymentInfoModal('La operación no ha podido ser completada, intente de nuevo más tarde.');
                        }
                    }
                },
                error: function (errorThrown) {
                    if (type_request != "tlmk") {
                        $("#tech-error-payway").html("No se logro realizar la petición");
                        tech.formFunctions.toggleSpinnerBlock("enrollment-spinner", "enrollment-third-step", "", "", false);
                    } else {
                        hideSpinnerPayway();
                        showPaymentInfoModal('La operación no ha podido ser completada, intente de nuevo más tarde.');
                    }
                    $("#pay-button").show();
                }
            });

        }
    }
    function sendForm(event) {
        event.preventDefault();
        var form = document.querySelector('#payment-form');
        if (validateElement()==true) {
            var form = document.querySelector('#payment-form');
            if (decidirAgro !== true) {
                var factory = new FactoryDecidir();
                decidir = factory.create("developers", false);
            }
            decidir.createToken(form, sdkResponseHandler);
        } else {
            let btnPayment = document.querySelector('#pay-button');
            addEvent(btnPayment, 'click', sendForm);
        }
        return false;
    };
    function hideSpinnerPayway() {
        $("#payment-spinner-tlmk").css({
            "display": "none",
            "margin- top": "0em"
        });
        $("#payment-spinner").css({
            "display": "none",
            "margin- top": "0em"
        });
        $('#payment-spinner-tlmk-message').text('');
        $(".payment-form-wrapper").css({
            "display": "block"
        });
        $("#my-payment-form").css({
            "display": "block"
        });
        $("#pay-button").css({
            "display": "block"
        });
    }
    function showSpinnerPayway() {
        $("#payment-spinner-tlmk").css({
            "display": "block",
            "margin- top": "0em"
        });
        $("#payment-spinner").css({
            "display": "block",
            "margin- top": "0em"
        });
        $('#payment-spinner-tlmk-message').text('');
        $(".payment-form-wrapper").css({
            "display": "none"
        });
        $("#my-payment-form").css({
            "display": "none"
        });
        $("#pay-button").css({
            "display": "none"
        });
    }
    function getElementsPayway(elements) {
        let checkoutPayway = null;
        var today = new Date();
        var date = today.toISOString().slice(0, 10);
        var nuDate = date.replace('-', '').replace('-', '');
        if (elements != '') {
            var last = $('#enrollment-card-number-input').val().slice(-4);
            $('#Ntarjeta').val(last);
            var brandPayway = listPayments.find(payment => payment.id == $('#enrollment-card-branch-input').val())?.marca || '';

            if (type_request != "tlmk") {
                var plazosPayway = $('#input-plazos').val();
                var tipoPedido = ($('#crmEnrollmentData').val() == "null") ? 'Autonomo' : 'CRM';
                var infoPrecio = (tipoPedido == 'Autonomo') ? JSON.parse($("#priceInfo").val()) : JSON.parse($("#crmEnrollmentData").val());
                var precioPayway = plazosPayway > 1 ? (tipoPedido == 'CRM' ? infoPrecio.EnrollmentPrice : infoPrecio.InitialQuotaPrice) : (tipoPedido == 'CRM' ? infoPrecio.FinalPrice : infoPrecio.Price);
                checkoutPayway = {
                    OrderNumber: elements.numPedido,
                    IdPago: 0,
                    IdCustomer: `${elements.numPedido}_${nuDate.substring(0, 2)}_${today.getMinutes()}${today.getSeconds()}`,
                    EmailCustomer: $('#enrollment-email-input').val(),
                    IdTransaction: `${elements.numPedido}_${nuDate}_${today.getHours()}${today.getMinutes()}${today.getSeconds()}`,
                    PaymentMethodId: $('#enrollment-card-branch-input').val(),
                    Amount: precioPayway,
                    Description: $('#courseTitle').val(),
                    TokenFirstPayment: $('#paymentToken').val(),
                    Bin: $('#bin').val(),
                    User: 'portalTech NewForm',
                    installment: 1,
                    LastFour: last,
                    CardBrand: brandPayway,
                    CardType: $('#enrollment-card-type-input').val()
                }
            } else {
                checkoutPayway = {
                    OrderNumber: elements.NumPedido,
                    IdPago: elements.IdPago,
                    IdCustomer: `${elements.NumPedido}_${nuDate.substring(0, 2)}_${today.getMinutes()}${today.getSeconds()}`,
                    EmailCustomer: elements.Email,
                    IdTransaction: `${elements.NumPedido}_${nuDate}_${today.getHours()}${today.getMinutes()}${today.getSeconds()}`,
                    PaymentMethodId: $('#enrollment-card-branch-input').val(),
                    Amount: elements.Precio,
                    Description: elements.Titulo,
                    TokenFirstPayment: $('#paymentToken').val(),
                    Bin: $('#bin').val(),
                    User: 'portalTech',
                    installment: 1,
                    LastFour: last,
                    CardBrand: brandPayway,
                    CardType: $('#enrollment-card-type-input').val()
                }
            }
        } else {
            console.log('Error elements vacio ');
        }
        console.log(checkoutPayway);
        return checkoutPayway;
    }
    function getListTypePaymentMethod() {
        $('#enrollment-card-type-input').html('');
        let opt = `<option value="">Seleccionar</option>`;
        const listTypes = listPayments.map(payment => payment.tipoTarjeta);
        const finalList = [...new Set(listTypes)];
        console.log('lista2:');
        console.log(finalList);
        finalList.forEach(tipoTarjeta => {
            const cardTypeName = tipoTarjeta === 'TC' ? 'Crédito' : (tipoTarjeta === 'TD' ? 'Débito' : 'Prepago');
            opt += `<option value="${tipoTarjeta}">${cardTypeName}</option>`;
        });
        $('#enrollment-card-type-input').append(opt);
    }
    function getListPaymentMethod() {
        $('#enrollment-card-branch-input').html('');
        var type = $('#enrollment-card-type-input').val();
        if (type !="") {
            var opt = `<option value="">Seleccionar</option>`;
            for (var i = 0; i < listPayments.length; i++) {
                if (listPayments[i].tipoTarjeta == type) {
                    opt += `<option value="${listPayments[i].id}">${listPayments[i].marca}</option>`;
                }
            }
            $('#enrollment-card-branch-input').append(opt);
        } else {
            $("#tech-error-payway").html('Selecciona un valor valido');
        }
    }
}
export function validateElement() {
    const listElements = [
        { id: 'enrollment-name-card-input', type: 'text', name: 'Nombre de Titular', min:5, max:100 },
        { id: 'enrollment-id-card-input', type: 'text', name: 'Documento Nacional de Identidad', min:7, max:10 },
        { id: 'enrollment-card-number-input', type: 'text', name: 'Numero de Tarjeta', min:14, max:16 },
        { id: 'enrollment-card-month-expiry-input', type: 'text', name: 'Fecha de Expiración', min:1, max: 2},
        { id: 'enrollment-card-year-expiry-input', type: 'text', name: 'Fecha de Expiración', min:1, max:2 },
        { id: 'enrollment-card-cvv-input', type: 'text', name: 'CCV', min:2, max:4 },
        { id: 'enrollment-card-type-input', type: 'select', name: 'Tipo de Tarjeta', min:0, max:100 },
        { id: 'enrollment-card-branch-input', type: 'select', name: 'Marca de Tarjeta', min:0, max:100 }
    ];
    return listElements.every(({ id, name,min,max }) => {
        const value = $(`#${id}`).val();
        const isValid = value.trim() !== "" && value.length > min && value.length <= max;
        if (!isValid) {
            console.log(`#${id}-error---${name} es obligatorio`);
            $(`#${id}-error`).html(`${name} es obligatorio`);
            $(`#${id}`).css({ 'box-shadow': 'rgb(255, 53, 71) 0px 1px 0px 0px !important', 'border-bottom':'1px solid rgb(255, 53, 71) !important'});
        } else {
            $(`#${id}-error`).html('');
            $(`#${id}`).css({ 'box-shadow': 'rgb(0, 200, 81) 0px 1px 0px 0px !important', 'border-bottom': '1px solid rgb(0, 200, 81) !important' });
        }
        return isValid;
    });
}
export function formateDate() {
        let inputDate = $('#enrollment-card-expiry-input');
        let currentDate = inputDate.val();
        let firstSlap = false;
        let long = currentDate.length;
        let moth;
        let years;
        if ((long >= 2) && (firstSlap == false)) {
            moth = currentDate.substr(0, 2);
            if ((IsNumeric(moth)) && (moth <= 12) && (moth != "00")) {
                currentDate = currentDate.substr(0, 2) + "/" + currentDate.substr(3, 7);
                firstSlap = true;
            } else {
                currentDate = "";
                firstSlap = false;
            }
        } else {
            moth = currentDate.substr(0, 1);
            if (IsNumeric(moth) == false) {
                currentDate = "";
            }
            if ((long <= 2) && (firstSlap = true)) {
                currentDate = currentDate.substr(0, 1);
                firstSlap = false;
            }
        }
        if (long == 7) {
            years = currentDate.substr(3, 4);
            if (IsNumeric(years) == false) {
                currentDate = currentDate.substr(0, 6);
            } else {
                if (long == 8) {
                    if ((years == 0) || (years < 2000) || (years > 2100)) {
                        currentDate = currentDate.substr(0, 6);
                    }
                }
            }
    }
    console.log(currentDate);
    inputDate.val(currentDate);
    clDateExpiry();
        return currentDate;
    }
export function IsNumeric(value) {
    let ExpRegSoloNumeros = '[0-9]'
    let pattern = new RegExp(ExpRegSoloNumeros, 'i')
    if (!value.trim()) return false
    if (pattern.test(value)) {
        return true
    } else {
        return false
    }
}
export function clDateExpiry() {
    if ($("input[name=type_request]").val() != "tlmk") {
        let dateForm = $('#enrollment-card-expiry-input').val();
        let arrayDate = dateForm.split('/');
        $('#enrollment-card-month-expiry-input').val(arrayDate[0]);
        $('#enrollment-card-year-expiry-input').val(arrayDate[1]);
    }
}

export function showPaymentInfoModal(errorMessage) {
    $('#payment-info-modal').modal({
        keyboard: false,
        backdrop: 'static'
    });
    $('#message-payment-modal').html('<p>' + errorMessage + '</p>');
    $('#payment-info-modal').modal('show');
}
